function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

export var closest = function closest(node, selector) {
  if (!node) {
    return null;
  }

  var matchesSelector = node.matches || node.webkitMatchesSelector || node.mozMatchesSelector || node.msMatchesSelector;

  while (node) {
    if (matchesSelector.call(node, selector)) {
      return node;
    }

    node = node.parentElement;
  }

  return null;
};
/**
 * Immutably moves item in a given array.
 * @list {array}: initial array
 * @from {int}: index of item, which is supposed to get moved
 * @to {int}: index of target position, where item should be placed
 * @returns {array}: new instance of the array after movement is complete
 */

export var arrayMove = function arrayMove(list, from, to) {
  if (from > -1 && to > -1 && from !== to) {
    if (to > from) {
      // move right
      // [item, item, item, from, item, item, to, item, item]
      // ---------1--------|--3--|-------2-------|-----4-----
      return _toConsumableArray(list.slice(0, from)).concat(_toConsumableArray(list.slice(from + 1, to + 1)), [list[from]], _toConsumableArray(list.slice(to + 1)));
    } // move left
    // [item, item, item, to, item, item, from, item, item]
    // ---------1--------|-------3-------|--2--|-----4-----


    return _toConsumableArray(list.slice(0, to)).concat([list[from]], _toConsumableArray(list.slice(to, from)), _toConsumableArray(list.slice(from + 1)));
  }

  return list;
};
export var getFullDisplayPreference = function getFullDisplayPreference(item) {
  return _objectSpread({
    type: 'text',
    display: false,
    configurable: true
  }, item);
};